<template lang="html">
  <div class="rear-content" :class="{ isRkhy: isRkhy }">
    <div v-if="workerInfo && workerInfo.uid">
      <div class="head-bg"></div>
      <div class="head-info">
        <!-- <div class="head-tag"></div> -->
        <div class="user-img">
          <img :src="workerInfo.headImage | avatarCert(97, 97)" />
        </div>
        <div class="showCertBg">
          <i :class="[identityLabelObj && identityLabelObj.icon]"></i>
        </div>
        <!-- <div v-if="!isCzjApp" class="atten">
                    <div class="follow-trigger hasFocus" v-if="this.is_follow && show_follow_relation" @click="unfollow"><i class="iconfont icon-shoucang"></i>已关注</div>
                    <div class="follow-trigger" v-if="!this.is_follow && show_follow_relation" @click="follow"><i class="iconfont icon-jia"></i>关注</div>
                </div> -->
        <div class="user-ifr">
          <div class="name-tag">
            <p class="name">
              <span>{{ workerInfo.workerName }}</span>
            </p>
            <ul class="tags" v-if="workerInfo.workCategorys">
              <li v-for="attr in workerInfo.workCategorys">
                <span>{{ attr.categoryName }}</span>
              </li>
            </ul>
          </div>
          <!-- <div class="score-info">
                        <star size="medium" :score="startLevelNum" color="#ffc600" @click.native="toStart()"></star>
                    </div> -->
          <div class="label-item">
            <p>
              <span v-if="workerInfo.age"
                >{{ workerInfo.age }}岁&nbsp;&nbsp;</span
              >{{ workerInfo.place ? `${workerInfo.place}人` : '' }}
            </p>
          </div>
        </div>

        <ul class="small-block">
          <!-- <li class="part"><span class="txt" v-if="workerInfo.goodCommentNum"><i>{{toDecimal(commentScaleNum)}}</i>%</span><span class="txt" v-else>0</span><p class="title">好评</p></li> -->

          <li class="part" v-if="workerInfo.servicedTimes">
            <div class="txt">
              <i>{{ workerInfo.servicedTimes || 0 }}单</i>
            </div>
            <label class="title">历史服务</label>
          </li>
          <li class="part part2">
            <div class="txt">
              <i>{{ workerInfo.workAge }}</i
              >年
            </div>
            <label class="title">工作经验</label>
          </li>
        </ul>
        <serviceAearComponent
          :schedualAreasStr="schedualAreasStr"
        ></serviceAearComponent>

        <div
          class="g-section"
          v-if="workerInfo.introduce && workerInfo.introduce !== ''"
        >
          <div class="abstract-layout">
            <div class="abstract">
              <p class="txt">{{ workerInfo.introduce }}</p>
              <!-- <p class="intro-hidden" v-model="shortProfile">{{workerInfo.introduce}}</p>
                            <p class="txt" :class="{ 'ui-nowrap-multi': profileArr.isLong }">{{workerInfo.introduce}}</p>
                            <a class="btn" v-if="profileArr.isShow" :class="{ active: profileArr.isActive }" @click="profileFn"><i class="iconfont icon-youjiantou"></i></a> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="person-promotions" v-if="posters.length > 0">
                <promotionPanel class="person-poster" :height="250" :posters="posters" v-on:clickImage="clickImg(index)"></promotionPanel>
            </div> -->
      <div class="rear-main">
        <article
          class="block-layout"
          v-if="credentialsNameArr && credentialsNameArr.length > 0"
        >
          <h2><p>认证信息</p></h2>
          <section>
            <div
              class="certificate"
              v-if="credentialsNameArr && credentialsNameArr.length > 0"
            >
              <div class="part" v-for="(item, index) in credentialsNameArr">
                <i class="icon"></i><span>{{ item.name }}</span>
              </div>
              <p v-if="workerInfo.uid" class="part bus-lice">
                <a
                  :href="`/v/user/${workerInfo.uid}/licence?cmd=share&sharetype=0&userType=6`"
                  ><i class="icon"></i><span>营业执照</span></a
                >
              </p>
            </div>
          </section>
        </article>
        <article
          class="block-layout serve-section"
          v-if="userInfo.spuList && userInfo.spuList.length > 0 && !isNewYuesao"
        >
          <h2><p>服务项目</p></h2>
          <section>
            <div class="ui-scroller">
              <ul>
                <li
                  v-for="(item, i) in userInfo.spuList"
                  @click="toProduct(item.spuId, i, item)"
                >
                  <div class="img-ui">
                    <img :src="item.cmmdtyImage | avatar(270, 162)" />
                  </div>
                  <div class="detail">
                    <p class="ui-nowrap-multi name">{{ item.spuName }}</p>
                    <div class="bottom-ui">
                      <div class="price" v-if="item.minPrice === item.maxPrice">
                        &yen;<span>{{ item.minPrice | priceNum }}</span>
                      </div>
                      <div class="price" v-else>
                        &yen;<span>{{ item.minPrice | priceNum }}</span
                        >-&yen;<span>{{ item.maxPrice | priceNum }}</span>
                      </div>
                      <button>购买</button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </article>
        <addIm :uid="uid" />
        <!--服务风采-->
        <article
          class="block-layout serve-eleg"
          v-if="userInfo.picUrls && userInfo.picUrls.length > 0"
        >
          <h2><p>服务风采</p></h2>
          <section>
            <div class="ui-scroller">
              <ul>
                <li
                  v-for="(item, i) in userInfo.picUrls"
                  @click="showImage(userInfo.picUrls, i)"
                >
                  <div class="img-ui">
                    <img :src="item | avatar(180, 180)" />
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </article>
        <!--用户评价-->
        <article
          class="block-layout member-evaluate-section"
          v-if="memberComment && memberComment.total > 0"
        >
          <commentEnter
            :commentData="memberComment"
            :id="workerInfo.workerCode"
            :uid="uid"
            toAllComment="certified"
          ></commentEnter>
        </article>
        <!-- <div class="g-section member-evaluate-section" v-if="experience && experience.feed_id">
                    <div class="g-title">
                        <h2>我的育儿经</h2>
                        <a href="javascript:;" @click="toExperience(21187)">
                            <span class="more">更多<i class="iconfont icon-jiantou"></i></span>
                        </a>
                    </div>
                    <div class="g-info">
                        <div class="g-info-comment">
                            <postItem :experience="experience" :ommitContent="true"></postItem>
                        </div>
                        <div class="seeAllComment">
                            <a href="javascript:;" @click="toExperience(21188)">更多 <i class="iconfont icon-jiantou"></i></a>
                        </div>
                    </div>
                </div> -->
        <!-- 服务排期 -->
        <!-- <scheduleCalendar class="schedule-service-layout" :uid="uid" :workerCode="workerInfo.workerCode"></scheduleCalendar> -->
        <template v-if="isYuesao">
          <!-- 服务流程-->
          <article class="block-layout service-flow-ui">
            <h2><p>服务流程</p></h2>
            <section class="service-flow">
              <div class="img"></div>
            </section>
          </article>
          <!-- 质量保障-->
          <article class="block-layout">
            <h2><p>质量保障</p></h2>
            <section class="zl-bz">
              <div class="img"></div>
            </section>
          </article>
        </template>
        <!-- 服务保障-->
        <article class="block-layout">
          <h2><p>服务保障</p></h2>
          <section class="service-bz">
            <div class="img"></div>
          </section>
        </article>

        <!-- <div class="g-section identify-section">
                    <div class="g-title">
                        <h2>孩子王平台认证</h2>
                    </div>
                    <div class="g-info">
                        <p class="txt">{{workerInfo.workerName}}通过了孩子王平台的认证，基础分{{workerInfo.initScore}}，以优异的成绩入驻孩子王。</p>
                        <div class="msg">
                            <div class="part g-right-line" @click="toLink(1)">
                                <span class="icon icon1"></span>
                                <div class="name">
                                    <p>平台入驻门槛</p>
                                    <span>严格筛选<i class="iconfont icon-youjiantou"></i></span>
                                </div>
                            </div>
                            <div class="part" @click="toLink(2)">
                                <span class="icon icon2"></span>
                                <div class="name">
                                    <p>申请入驻</p>
                                    <span>成为认证育儿师<i class="iconfont icon-youjiantou"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
        <div class="businessName">
          <span
            v-if="
              workerInfo &&
              workerInfo.businessName &&
              workerInfo.businessName !== ''
            "
            >由第三方机构提供</span
          >
        </div>
      </div>
      <actionbar v-if="isCzjApp">
        <button class="btns btn-pink" slot="buttons">
          <a
            class="ui-border-r btn pingjia"
            :href="`/v/evaluate?workerUid=${workerInfo.uid}&ht=add`"
          >
            <span>评价</span>
          </a>
        </button>
      </actionbar>
      <actionbar v-else-if="!isRkhy" class="rearAction">
        <!-- <li slot="icons">
                    <a class="ui-border-r btn pingjia" :href="`/v/evaluate?workerUid=${workerInfo.uid}&ht=add`" @click="trackClick(200009, {fuid: fuid}, `fuid:${fuid}`,121011913)">
                        <i class="pingjia"></i><span>评价</span>
                    </a>
                </li> -->
        <!-- <button class="btns btn-ccc" slot="buttons" @click="unfollow" v-if="this.is_follow && show_follow_relation"><a><i class="iconfont icon-yihaoyou"></i>已加好友</a></button>
                <button class="btns btn-cancel" slot="buttons" @click="follow" v-if="!this.is_follow && show_follow_relation"><a><i class="iconfont icon-jiahaoyou"></i>加为好友</a></button> -->
        <!-- <button class="btns btn-pink btn-round" slot="buttons"><a class="ui-border-r contactMe linkedme" :href="`https://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${workerInfo.uid}`" @click="toIM($event)"><i class="iconfont icon-liaotian"></i>一键咨询</a></button> -->
        <div class="btns btn-pink btn-round" slot="buttons" v-if="!isNewYuesao">
          <a class="ui-border-r contactMe linkedme" @click="toIM($event)"
            >一键咨询</a
          >
        </div>
        <div class="btns" slot="buttons" v-else>
          <div class="btn-list">
            <button class="buy-yuesao" @click="toConfirmYuesao">
              预定月嫂
            </button>
            <button class="consult-ui" @click="toIM($event)">立即咨询</button>
          </div>
        </div>
      </actionbar>
    </div>
    <empty
      v-else
      v-show="!firstFetch"
      :image="require('../../assets/images/empty1.png')"
      text="未找到相关信息"
    ></empty>
    <imagePreview :items="previewImages"></imagePreview>
    <mt-popup v-model="skuListVisible" position="bottom">
      <CertifiedSkuList
        :workerInfo="workerInfo"
        @handleClose="
          () => {
            this.skuListVisible = false
          }
        "
      >
      </CertifiedSkuList>
    </mt-popup>
    <!--不要删除,兼容iphonex -->
    <div class="menu_wkBox_back_box"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Popup from '@/components/action-sheet/popup'
//import star from '@/components/common/star'
// import commentItem from '@/components/rear/item'
//import postItem from '@/components/rear/item-experience'
import CertifiedSkuList from '@/components/rear/certifiedSkuList'
import imagePreview from '@/components/common/viewImage'
//import scheduleCalendar from './scheduleCalendar'

import empty from '@/components/common/empty'
import actionbar from '@/components/order/actionbar'
// import shoppingList from '@/components/rear/shoppingList'
import promotionPanel from '@/components/promotion'
import addIm from '@/components/common/im'

import changePrivinceCodeToCityCode from '@/plugins/changeCityCode'
import serviceAearComponent from './serviceAear.component'

import { identityLabel } from '@/plugins/enum'
//import isIOS from '@/plugins/isIOS'

import commentEnter from '@/components/newComment/commentEnter'

import { trackClick } from '@/router/rear/ys_detail_tracker.js'

export default {
  PAGE_ID: '121011913',
  data() {
    return {
      fuid: '',
      uid: null,
      attrsTxt: [],
      credentialsNameArr: [],
      profileArr: {
        isLong: false,
        isShow: false,
        isActive: false
      },
      schedualAreasStr: [],
      moveX: 0,
      pageX: null,
      // evaluateLis: [],
      // evaluateLisNum: null,
      firstFetch: true,
      is_follow: false,
      show_follow_relation: false,
      memberComment: {},
      experience: {},
      circleId: '', // 育儿经圈子id，从cms取
      // shoppingList: {},
      posters: [], // 促销海报
      dateFormat: {
        y: '',
        m: '',
        month: ''
      },
      isShowAreaAll: false,
      skuListVisible: false //规格弹出显示
    }
  },
  async created() {
    this.trackView()
    this.trackBT(121012450)()
    this.fuid = this.$$cookie('uid') || ''
    this.uid = this.$route.params.uid || this.$$cookie('uid')
    await this.getUserInfo()

    this.$$loading(false)
    const name = this.workerInfo.workerName
    const genius = this.workerInfo.workCategorys
      .map(ele => ele.categoryName)
      .join('、')
    const desc = `孩子王育儿服务平台${name}为您提供专业服务,擅长${genius}`
    const shareRemark = {
      // https://doc.weixin.qq.com/sheet/e3_AHcAFgYQAOQ5JzaHs1ySymwTlnHNW
      // toolType
      // 401	服务分享赚
      // 402	心愿单
      // 403	代客下单
      // --------------
      // contentType\contentId
      // 201	服务商祥	SPUID
      // 202	服务拼团商祥	SKUID
      // 203	服务景区详情	SPUID
      // 204	服务频道页	CHANNEL_ID
      // 205	服务天天特价频道页
      // 206	服务晒图有奖
      // 207	服务店铺	BUSINESSID
      // 208	服务人格化主页	WORKERID
      // toolType,
      // toolCode,
      url: encodeURIComponent(location.href),
      contentType: 208,
      contentId: this.workerInfo.uid || ''
      // storeCode,
      // groupId,
      // phoneNumber
    }
    this.$$share({
      link: `https://life.cekid.com/v/user/${this.uid}`,
      desc,
      title: `认证育儿师${name}的名片`,
      imgUrl: this.workerInfo.headImage,
      remark: JSON.stringify(shareRemark)
    })
    const shareInfo = {
      title: `认证育儿师${name}`,
      desc: '孩子王，中国新家庭全渠道服务商！',
      link: `https://life.cekid.com/v/user/${this.uid}`,
      imgUrl: this.workerInfo.headImage
    }
    window.getImInfo = () => shareInfo
  },
  async mounted() {
    try {
      // this.getShoppingList()
      this.getMemberEvaluate()
      this.getPromotions()
      const config = await this.$store.dispatch('getMainConfig')
      this.circleId = config.data.circleId
      // 此接口已弃用
      // this.getExperience()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    // ...mapMutations(),
    async getUserInfo() {
      try {
        const rlt = this.workerInfo
        const attrObj = rlt.attrs
        if (rlt.workerCredentials) {
          let arr = rlt.workerCredentials || []
          arr = arr.filter(v => v.name && v.name !== '营业执照')
          this.credentialsNameArr = arr.length > 3 ? arr.splice(0, 3) : arr
        }

        const areasArr = []
        const areasObjArr = []
        const areas = this.userInfo.area
        let isAll = false
        if (areas && areas.length > 0) {
          areas.forEach((v, i) => {
            if (
              v.cityId === '-1' &&
              v.provinceId === '-1' &&
              v.districtId === '-1'
            ) {
              isAll = true
            } else if (areasArr.indexOf(v.cityId) === -1) {
              areasArr.push(v.cityId)
            }
          })
          console.log(isAll)
          if (isAll) {
            this.schedualAreasStr.push('全国')
          } else {
            areasArr.forEach((v1, i1) => {
              areasObjArr[i1] = []
              areas.forEach((v2, i2) => {
                if (v2.cityId === v1) {
                  const obj = {}
                  if (
                    v2.cityId === '110100' ||
                    v2.cityId === '120100' ||
                    v2.cityId === '310100' ||
                    v2.cityId === '500100'
                  ) {
                    obj.cityName = v2.provinceName
                  } else {
                    obj.cityName = v2.cityName
                  }
                  obj.districtName = v2.districtName
                  areasObjArr[i1].push(obj)
                }
              })
            })

            areasObjArr.forEach((v, i) => {
              let str = ''
              const dist = []
              v.forEach((v1, i1) => {
                if (i1 === 0) {
                  str += `${v1.cityName}：`
                }
                dist.push(v1.districtName)
              })
              str += dist.join('.')
              this.schedualAreasStr.push(str)
            })
          }
        }

        this.$$title(`认证育儿师${this.workerInfo.workerName}`)

        const user_shequ = await this.$store.dispatch('getUserInfoFromShequ', {
          to_uid: this.uid
        })
        this.show_follow_relation = true
        if (user_shequ.code === 1001) {
          this.is_follow = user_shequ.data.is_follow
        }
        this.firstFetch = false
      } catch (e) {
        // this.$$toast('网络异常，请刷新重试')
        this.firstFetch = false
        this.hasErr = true
      }
    },
    async getPromotions() {
      const promotions = await this.$store.dispatch('getPagePromotions')
      const page = promotions.data.personProfile
      if (page && page.promotions) {
        this.posters = page.promotions
      }
    },
    // profileFn() {
    //     if (this.profileArr.isLong) {
    //         this.profileArr.isLong = false
    //         this.profileArr.isActive = true
    //     } else {
    //         this.profileArr.isLong = true
    //         this.profileArr.isActive = false
    //     }
    // },

    // async getShoppingList() {
    //     const res = await this.$store.dispatch('getShoppingList', { uid: this.uid })
    //     if (res.errno === 0) {
    //         this.shoppingList = res.data || {}
    //     }
    // },
    // toStart() {
    //     location.href = 'https://cms.cekid.com/publish/998/xingjipingding.html?activeId=9902'
    // },
    // toLink(x) {
    //     if (x === 1) {
    //         location.href = 'https://cms.cekid.com/publish/998/ruzhu.html?activeId=9900'
    //     } else if (x === 2) {
    //         location.href = 'https://cms.cekid.com/publish/999/activity/104.html?&cmd=share&sharetype=0'
    //     }
    // },
    async toIM() {
      // this.trackClick(200008, {fuid: this.fuid}, `fuid: ${this.fuid}`, 121011913)
      trackClick('TOGGLE_CITY')
      // const appPageSource = 'HD0101'
      // const h5PageSource = 'HD0201'
      // const param = {
      //     shop: 3,
      //     businessType: '07',
      //     customerId: this.$$cookie('uid')
      // }
      // this.$$kefu(appPageSource, h5PageSource, param);
      if (!this.$$isHZWApp() && !this.$$isRkhy()) {
        window.location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${this.workerInfo.uid}` //app下载页
        return
      }
      try {
        const cityId =
          this.userInfo.area && this.userInfo.area.lenght
            ? this.userInfo.area[0].cityId
            : '320100'
        let count = 0
        const serviceAreasStr =
          this.schedualAreasStr
            .reduce(
              (previousValue, currentValue, index, array) =>
                `${previousValue}.${currentValue}`,
              this.schedualAreasStr[0]
            )
            .split('.')
            .filter((item, index) => index < 10)
            .join('、') + '...'

        const ageContent = this.workerInfo.age
          ? `年龄：${this.workerInfo.age}岁`
          : ''
        const nativePlaceContent = this.workerInfo.place
          ? `籍贯：${this.workerInfo.place}`
          : ''
        let lineContent = ''
        if (ageContent) {
          lineContent = `${ageContent} ${nativePlaceContent}\n`
        } else if (!ageContent && nativePlaceContent) {
          lineContent = `${nativePlaceContent}\n`
        }

        let msg = {
          font: '',
          color: '',
          message: `${this.workerInfo.workerName}\n${lineContent}服务区域：${serviceAreasStr} 经验：${this.workerInfo.workAge}年+`
        }
        const { uid: userUid, skey } = await this.$$ensureLogin()
        let data = await this.$store.dispatch('queryWorkerIm', {
          uid: userUid,
          cityId,
          msg: JSON.stringify(msg)
        })
        const imInfo = (data && data.data) || {}
        const { uid, businessKey } = imInfo
        if (uid && businessKey) {
          location.href = `//api.appc.cekid.com/?cmd=imconversation&userid=${uid}&scenetype=11&businesskey=${encodeURIComponent(
            businessKey
          )}&appcode=HZW_MALL`
        } else {
          this.$$toast(data.msg)
        }
      } catch (e) {
        this.$$toast('系统发生异常')
        console.log(e)
      }
    },
    toDecimal(x) {
      let f = parseFloat(x)
      if (isNaN(f)) {
        return
      }
      f = Math.round(x * 100) / 100
      return f
    },
    toCertificate() {
      this.$router.push({
        name: 'certificate',
        params: {
          uid: this.uid
        }
      })
    },
    // showHeadImage(images) {
    //     const arr = [images]
    //     const index = 0
    //     this.$store.commit('setPreviewImages', arr)
    //     this.$router.push({ query: { preview: true, index } })
    // },
    showImage(images, index) {
      this.$store.commit('setPreviewImages', images)
      this.$router.push({ query: { preview: true, index } })
    },
    toProduct(spuId, i, item) {
      // 埋点
      const index = i + 1
      const uid = this.$route.params.uid || this.$$cookie('uid') || ''
      this.trackClick(
        200001,
        { spuid: spuId, name: item.spuName, fuid: this.fuid },
        `spuId: ${spuId},name: ${item.spuName},fuid: ${this.fuid}`,
        121011913,
        index
      )
      location.href = `/v/product/${spuId}?empid=${
        this.workerInfo.workerCode
      }&refresh=no&hserecomkey=${this.$route.query.hserecomkey || ''}`
      // this.$router.push({
      //     name: 'product-detail',
      //     params: {
      //         spuId: skuCode
      //     },
      // })
    },
    toAllWork() {
      this.trackClick(200002, '点击更多排期')
    },
    toEvaluate() {
      location.href = `//life.cekid.com/v/user/${this.uid}/comment/add`
    },
    async follow() {
      this.trackClick(200004, '点击加好友')
      const follow_res = await this.$store.dispatch('doFollow', {
        follow_id: this.uid
      })
      if (follow_res && follow_res.code === 1001) {
        this.is_follow = true
        const ele_toast = document.querySelectorAll('.cekid-toast')
        if (ele_toast && ele_toast.length > 0) {
          ele_toast.forEach(ele => {
            if (ele.parentNode) {
              ele.parentNode.removeChild(ele)
            }
          })
        }
        this.$$toast('已加好友，可在通讯录中查看')
      } else if (follow_res.code === 1005) {
        this.$$login()
      }
    },
    async unfollow() {
      const follow_res = await this.$store.dispatch('deleteFollow', {
        follow_id: this.uid
      })
      if (follow_res && follow_res.code === 1001) {
        this.is_follow = false
        const ele_toast = document.querySelectorAll('.cekid-toast')
        if (ele_toast && ele_toast.length > 0) {
          ele_toast.forEach(ele => {
            if (ele.parentNode) {
              ele.parentNode.removeChild(ele)
            }
          })
        }
        // this.$$toast('取消关注成功')
      } else if (follow_res.code === 1005) {
        this.$$login()
      }
    },
    async getMemberEvaluate() {
      const comment = await this.$store.dispatch('getNewCommentList', {
        page: 1,
        size: 2,
        workerCode: this.workerInfo.workerCode,
        type: 99,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey'),
        property: 2 // 短评
      })
      if (+comment.code === 1) {
        this.memberComment = comment.data
      } else {
        this.$$toast({
          message: comment.msg
        })
      }
    },
    toExperience(num) {
      this.$router.push({
        name: 'experience',
        params: {
          uid: this.uid
        },
        query: {
          circleId: this.circleId
        }
      })
    },
    async getExperience() {
      if (!this.circleId || this.circleId === '') {
        return
      }
      try {
        const exp = await this.$store.dispatch('getYuerExperience', {
          to_uid: this.uid,
          column_tag_id: this.circleId
        })
        if (exp && exp.code === 1001) {
          this.experience = exp.data
        }
      } catch (e) {
        console.error(e)
      }
    },
    toConfirmYuesao() {
      // 购买
      trackClick('ENTER_YS_DETAIL')
      this.skuListVisible = true
    }
  },
  components: {
    //star,
    // commentItem,
    imagePreview,

    empty,
    actionbar,
    //postItem,
    // shoppingList,
    promotionPanel,
    addIm,
    //scheduleCalendar,
    serviceAearComponent,
    commentEnter,
    CertifiedSkuList,
    'mt-popup': Popup
  },
  computed: {
    ...mapState(['userInfo', 'previewImages', 'mainConfig']),
    workerInfo() {
      return this.userInfo.worker
    },
    commentScaleNum() {
      return this.userInfo.commentScale * 100
    },
    startLevelNum() {
      return this.userInfo.startLevel * 2
    },
    shortProfile() {
      if (this.userInfo.profile && this.userInfo.profile.length > 45) {
        this.profileArr.isLong = true
        this.profileArr.isShow = true
      }
    },
    isCzjApp() {
      return this.$$isCZJApp()
    },
    isRkhy() {
      return this.$$isRkhy()
    },
    identityLabelObj() {
      return identityLabel(this.workerInfo.userTypeName || '')
    },
    isYuesao() {
      return (
        this.identityLabelObj.type === 'signed' ||
        this.identityLabelObj.type === 'joint'
      )
    },
    isNewYuesao() {
      return (
        this.userInfo &&
        this.userInfo.signSku &&
        this.userInfo.signSku.length != 0
      )
    }
  }
  // directives: {
  //     intro: (el, binding, vnode) => {
  //         console.log(vnode.context);
  //         if (el.offsetHeight > 40) {
  //             this.default.data.profileArr.isLong = true
  //             this.default.data.profileArr.isShow = true
  //         }
  //     }
  // }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.rear-content {
  padding-top: 0;
  &.isRkhy .rear-main {
    padding-bottom: 0;
  }
  .head-bg {
    margin-bottom: rem(-40px);
    width: 100%;
    height: rem(220px);
    background: url(../../assets/images/bg_certifileP@3x.png) no-repeat;
    background-size: cover;
  }
  .head-info {
    position: relative;
    padding: rem(30px);
    width: 100%;
    background: #ffffff;
    border-top-left-radius: rem(20px);
    border-top-right-radius: rem(20px);
    margin-bottom: rem(20px);
    .user-img {
      position: absolute;
      top: 0;
      left: rem(26px);
      margin: rem(-90px) 0 0 0;
      width: rem(186px);
      height: rem(186px);
      background: #ffffff;
      border-radius: 50%;
      border: rem(3px) #ffffff solid;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .showCertBg {
      width: 100%;
      overflow: hidden;
      i {
        display: inline-block;
        float: right;
        height: rem(50px);
        background-position: right top;
        width: rem(220px);
        background-repeat: no-repeat;
        &.signed-two {
          background-image: url('~@/assets/images/lab_ys_two.png');
          background-size: rem(158px) auto;
        }
        &.signed-three {
          background-image: url('~@/assets/images/lab-ys-three@3x.png');
          background-size: rem(158px) auto;
        }
        &.signed-four {
          background-image: url('~@/assets/images/lab-ys-four@3x.png');
          background-size: rem(158px) auto;
        }
        &.signed-five {
          background-image: url('~@/assets/images/lab-ys-five@3x.png');
          background-size: rem(158px) auto;
        }
        &.signed-gold {
          background-image: url('~@/assets/images/lab-ys-gold@3x.png');
          background-size: rem(161px) auto;
        }
        &.signed-senior {
          background-image: url('~@/assets/images/lab-ys-zs@3x.png');
          background-size: rem(162px) auto;
        }
        &.signed-diamond {
          background-image: url('~@/assets/images/lab_ys_diamond.png');
          background-size: rem(158px) auto;
        }
        &.joint {
          background-image: url('~@/assets/images/lab-ys-joint@3x.png');
          background-size: rem(120px) auto;
        }
        &.cert {
          background-image: url('~@/assets/images/lab-yrs@3x.png');
          background-size: rem(187px) auto;
        }
      }
    }
    .atten {
      width: 100%;
      overflow: hidden;
      .follow-trigger {
        float: right;
        margin-right: 0;
        background-image: linear-gradient(-44deg, #ff2676 0%, #ff669e 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: rem(26px);
        border-radius: rem(60px);
        width: rem(180px);
        height: rem(60px);

        .icon-shoucang {
          font-size: rem(24px);
          margin-right: rem(10px);
          font-weight: bold;
        }
        i {
          margin-right: rem(16px);
        }
        &.hasFocus {
          @include border(all, #ff397e, 1px, 25px);
          color: #ff397e;

          // border:
        }
      }
    }
    .user-ifr {
      padding-top: rem(32px);

      .name-tag {
        display: flex;

        align-content: center;
        .name {
          flex: none;
          color: #121212;
          font-size: rem(36px);
          text-align: center;
          padding-right: rem(20px);
          span {
            display: inline-block;
            vertical-align: bottom;
          }
          .service-star {
            display: inline-block;
            margin-left: rem(20px);
            width: rem(28px);
            height: rem(34px);
            background-image: url('../../assets/images/service-star.png');
            background-size: cover;
            background-repeat: no-repeat;
          }
        }
        .tags {
          display: flex;
          flex-wrap: wrap;
          li {
            height: rem(34px);
            line-height: rem(34px);
            font-size: rem(22px);
            padding: 0 rem(12px);

            color: #ff397e;
            margin: rem(6px);
            @include border(all, #ff397e, 1px, 0.34rem);
          }
        }
      }

      .label-item {
        margin-top: rem(16px);
        color: #666;
        font-size: rem(26px);
        line-height: rem(32px);
        text-align: left;
      }
    }

    .score-info {
      display: flex;
      justify-content: center;
      margin-top: rem(10px);
      width: 100%;
    }

    .small-block {
      display: flex;
      flex-wrap: wrap;
      margin-top: rem(20px);
      > li {
        display: flex;

        align-items: baseline;
        padding-right: rem(48px);
        > label {
          font-size: rem(26px);
          color: #666666;
        }
        > div {
          font-weight: 600;
          font-size: rem(30px);
          color: #ff397e;
          padding-right: rem(8px);
        }
      }
    }

    .serve-tags {
      margin: rem(5px) rem(20px) 0;
      padding-bottom: rem(30px);
      @include border(bottom, #e5e5e5);
      span {
        display: inline-block;
        margin: rem(20px) rem(20px) 0 0;
        padding: rem(5px) rem(10px);
        border-radius: rem(4px);
        color: #666666;
        font-size: rem(22px);
        line-height: rem(22px);
        @include border(all, #ccc, 1px, 2px);
      }
    }
    .bottom-line {
      display: flex;
      padding: rem(22px) rem(20px);
      color: #666666;
      font-size: rem(24px);
      .iconfont {
        margin-right: rem(10px);
        font-size: rem(22px);
      }
      .address {
        // max-width: rem(160px);
        line-height: 1.2;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        .iconfont {
          color: #666666;
        }
      }
    }
    .head-tag {
      position: absolute;
      top: 0;
      left: 0;
      width: rem(90px);
      height: rem(90px);
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACECAMAAABmmnOVAAAAQlBMVEUAAAD/mzn/mzn/mzn/mzn/mzn/mzn/////o07/7eH/+fX/snH/2sD/x5z/zaj/uYD/59b/qmD/8+v/4cv/1LX/wI66LqwwAAAABnRSTlMAYnl6UBhr0uQuAAADrklEQVR42uzY2W6jQBAF0Fnr9lq9gP//VycMY18IRKMo7iIPuU+2ZMmnqwoa+tuH80M+mt/PN6T0TsOvAQagvMvwfYghfxk+jUE/gQEhXm7QQEW7bB7iQ5FCvGomH4oEIowNd8U1Bl0Nd8VkaGCcfzFQcYWBaezIZYYUIhWGhlZr9fC6NgUnija+DgV/U+UtRQxpeC9aLkuivFbwg3dm83CmMDe4M4WxIfkzhbEBOFNYG8JBEc3rkOMrhbWhBWQu3K2KPNwwx93XmIXlT8ktCow26HFvoKJCRcpgA0fvXFGRDebhPwqPIt1kJl1Hd+cKoEisgw1cc3xDEQ2eYfhv80kxbsBwA5MBBD02Sut4A6MA0LPpO84xFWECujp7A+MC5pYApJuZoUy1BiDvhrBISwEIk5bRBs4AoMIk9KUi2WNJr3F4L4qWJW3fkLUwTScCbeaBUfTNXqrZzOCEacBNGDuDT8JMmC4xABtFRrjEEAKoaEC5whDjVtGhxga5IUSRu6I4kYpkZGDyi+GhmEORGdXOwFBRUURRn274KQzPQZLmclQQMdjAPQN90rJXEDHaILFknSrWuK0CaFI0jzQ4nXfvO5o60r4jkMHzsCt0Xp8jWtv/wA+fyQJw0dDD5iUupeEz6QC+dieexzAW1yZQ7vdqz/MYW4PUf4gK7zbnMYYGIhJC253HWBpkhm4OIxJ4HmNnEF0QGbjRQMV4AxE3INNAxXgDETFAaViTQcVAAxEBiQberVHHGhwXOQGnBl96HGvwLHUH/NHwtF4wf5izlxyGQRgIoLMK+TYiJfe/ahPRZqjsrUewZOMnDMYIY2CMfOdeYYBj4FUuMsAanC/wYAOsYV/ZKvFARhpg16GwVaEi1ABjuPdjtopIA5z9MKUyWEWgAcbA1nE8W0WgATTUG5v5uKZaRaABXIfpURxp49I0GYkygLng90E5zsdAxbxEGdDsh0cxemVrizOABir80hlnAANSoTaAAalQG1AfFX+KXW1A/a46pldmwVAbUK/HdI339itVadcaMFRFOVK6EvFdiXlRGYiojnVO+TZMmbUz3GD7ia2eC9YLjcFv76jQGOAYqBAZYA1UqAxwDFSIDHAMfIqJDDBBOSEzwATlkBlgA+oN6MGAHgzowYAeDJ9m56AAABgEgBCPzf6RjeGRAIWDwkHhoHBQOCgcFA4KB4WDwkHhoHBQOCgcFA4KB4WDwkHhoHBQOCgcFA4KB4WDwkHhoHBQOCgcFA7muffdW/aWq58WlSeJAAAAAElFTkSuQmCC');
      background-size: cover;
    }
  }
  .person-promotions {
    margin-top: rem(20px);
  }
  .person-poster {
    height: rem(250px);
    img {
      height: rem(250px);
    }
  }
  .abstract-layout {
    margin: rem(30px) 0;
    margin-bottom: 0;
    background: #fafafa;
    border-radius: rem(12px);
    padding: rem(24px);
  }
  .abstract {
    position: relative;
    color: #666666;
    padding: 0 rem(34px);
    font-size: rem(26px);
    background: url('~@/assets/images/icon-quot-up@3x.png'),
      url('~@/assets/images/icon-quot-down@3x.png');
    background-repeat: no-repeat;
    background-size: rem(22px) auto;
    background-position: left top, right bottom;
    .txt {
      line-height: rem(42px);
    }
    .btn {
      display: block;
      margin: 0 auto;
      width: rem(40px);
      height: rem(40px);
      transform: rotate(90deg);
      transition: all 200ms;
      color: #999;
      .iconfont {
        font-size: rem(36px);
      }
    }
    .active {
      transform: rotate(-90deg);
    }
    .intro-hidden {
      position: absolute;
      // left: 0;
      // top: 0;
      z-index: -1;
      visibility: hidden;
      height: auto;
      padding-right: rem(20px);
    }
  }
  .schedule-service-layout {
    margin-bottom: rem(20px);
  }
  .block-layout {
    background-color: #fff;
    h2 {
      padding: rem(30px);
      align-items: center;
      display: flex;
      justify-content: space-between;
      p {
        font-size: rem(34px);
        color: #000;
        letter-spacing: 0;
        line-height: rem(42px);
        font-weight: 600;
      }
      a {
        display: inline-block;
        font-size: rem(24px);
        color: #999999;
        letter-spacing: 0;
        text-align: right;
      }
    }
  }
  .certificate {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    padding: rem(30px);
    padding-top: 0;
    padding-bottom: rem(14px);
    .part {
      display: flex;
      padding-right: rem(12px);
      padding-right: rem(48px);
      align-items: center;
      margin-bottom: rem(16px);
      &:last-child {
        padding-right: 0;
      }
      a {
        display: flex;
        align-items: center;
      }
      i.icon {
        display: block;
        width: rem(34px);
        height: rem(32px);
        background: url('~@/assets/images/icon-auth@3x.png') no-repeat left
          center;
        background-size: rem(24px) auto;
      }
      span {
        display: block;
        color: #333;
        font-size: rem(26px);
      }
    }
  }
  .rear-main {
    .businessName {
      width: 100%;
      height: rem(88px);
      font-size: rem(26px);
      color: #a6a6a6;
      text-align: center;
      line-height: rem(88px);

      & > span::before {
        content: '———';
        color: #ddd;
        margin-right: rem(10px);
      }

      & > span::after {
        content: '———';
        color: #ddd;
        margin-left: rem(10px);
      }
    }
    padding-bottom: rem(100px);

    .serve-section {
      //padding-bottom: rem(-6px);
      .ui-scroller {
        padding: 0;
        //padding-bottom: rem(27px);
        margin-bottom: rem(-6px);
        ul {
          padding: 0 rem(30px);
          li {
            display: flex;
            overflow: hidden;
            position: relative;
            padding: rem(36px) 0;
            @include border(bottom, #e8e8e8);
            .img-ui {
              width: rem(250px);
              height: rem(150px);
              overflow: hidden;
              border-radius: rem(12px);
              flex: none;
              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            .detail {
              margin-left: rem(24px);
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              flex: auto;
              .name {
                color: #121212;
                font-weight: 500;
                font-size: rem(30px);
                line-height: rem(40px);
              }
            }

            .bottom-ui {
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              .price {
                width: 100%;
                color: #ff397e;
                font-size: rem(26px);
                span {
                  font-size: rem(36px);
                  font-weight: 600;
                }
              }
              button {
                flex: none;
                width: rem(100px);
                height: rem(48px);
                line-height: rem(48px);
                border-radius: rem(24px);
                color: #fff;
                font-size: rem(24px);
                background-image: linear-gradient(
                  -44deg,
                  #ff2676 0%,
                  #ff669e 100%
                );
              }
            }
            &:first-child {
              margin-top: rem(-36px);
            }
            &:last-child {
              @include border(bottom, #e8e8e8, 0);
            }
          }
        }
      }
    }
    .serve-eleg {
      padding-bottom: rem(30px);
      .ui-scroller {
        position: relative;

        ul {
          padding: 0 rem(21px);
          padding-bottom: rem(13px);
          overflow-x: auto;
          display: -webkit-box;
          &::-webkit-scrollbar {
            display: none;
          }

          li {
            display: flex;
            position: relative;
            justify-content: center;
            margin: 0 rem(9px);
            .img-ui {
              width: rem(180px);
              height: rem(180px);
              overflow: hidden;
              border-radius: rem(12px);
              flex: none;
              img {
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            &:last-child {
              padding-right: rem(30px);
            }
          }
        }
      }
    }
    .area-section {
      .g-info {
        padding: rem(20px);
      }
      p {
        color: #666666;
        font-size: rem(26px);
        line-height: rem(42px);
      }
    }
    .time-section {
      .g-title {
        position: relative;
        z-index: 2;
        padding-bottom: rem(24px);
        @include border(bottom, #e6e6e6);
      }
      .g-info {
        // padding: rem(20px);
      }
    }
    .to-all-comment {
      display: block;
      height: rem(60px);
      width: rem(208px);
      margin: 0 auto rem(20px);
      @include border(all, #cccccc, 1px, 30px);
      border-radius: rem(30px);
      font-size: rem(24px);
      color: #262626;
      text-align: center;
      line-height: rem(60px);
    }
    .evaluate-section,
    .member-evaluate-section {
      margin-bottom: rem(20px);
      padding: rem(30px) rem(30px) 0;

      .service-Title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: rem(30px);
        background: #fff;
        padding: 0 rem(30px);
        > p {
          font-weight: 700;
          font-size: rem(34px);
          color: #121212;
          line-height: rem(42px);
          > span {
            color: #999;
            font-size: rem(28px);
            font-weight: normal;
          }
          .number {
            font-size: rem(24px);
            color: #262626;
            line-height: rem(30px);
            font-weight: 700;
            margin-left: rem(12px);
          }
        }
        a {
          align-self: flex-start;
          line-height: rem(40px);
        }
        .more {
          display: flex;
          align-items: center;
          font-size: rem(24px);
          color: #262626;
          line-height: rem(30px);
        }
        .moreIcon {
          margin-left: rem(10px);
          width: rem(20px);
          height: rem(20px);
          background: url('../../assets/images/comment/icon-more.png') no-repeat
            center center;
          background-size: 100% 100%;
        }
      }
      .g-info {
        .g-info-comment {
          position: relative;
          padding: 0 rem(30px);
          .g-info-comment-content {
            & > div:last-child {
              &::after {
                border: 0;
              }
            }
          }
          .comment-item:last-child::after {
            border-bottom: 0 none;
          }
        }
        .seeAllComment {
          text-align: center;
          padding: rem(30px) rem(30px) rem(10px);
          font-size: rem(28px);
          @include border(top);

          &::before {
            left: rem(20px);
            right: rem(20px);
          }

          a {
            display: inline-block;
            padding: 0 rem(20px);
            height: rem(50px);
            line-height: rem(50px);
          }
          .icon-jiantou {
            font-size: rem(22px);
          }
        }
        .btn-bottom {
          display: block;
          margin: 0 auto rem(10px);
          width: rem(210px);
          height: rem(48px);
          font-size: rem(28px);
          color: #121212;
          line-height: rem(48px);
          text-align: center;
          @include border(all, #121212);
        }
      }
    }
    .identify-section {
      .g-info {
        .txt {
          padding: rem(30px) rem(20px);
          font-size: rem(26px);
          color: #666;
          // border-bottom: rem(1px) solid #E5E5E5;
          line-height: rem(42px);
          @include border(bottom, #e5e5e5);
        }
        .msg {
          display: flex;
          .part {
            display: flex;
            padding: rem(30px) 0 rem(30px) rem(40px);
            flex: 1;
            .icon {
              display: block;
              width: rem(80px);
              height: rem(80px);
              margin-right: rem(20px);
            }
            .icon1 {
              background: url(../../assets/images/icon1_bg.png) no-repeat;
              background-size: cover;
            }
            .icon2 {
              background: url(../../assets/images/icon2_bg.png) no-repeat;
              background-size: cover;
            }
            .name {
              flex: 1;
              p {
                padding: rem(10px) 0;
                font-size: rem(28px);
                color: #121212;
              }
              span {
                font-size: rem(24px);
                color: #999999;
              }
            }
            .icon-youjiantou {
              font-size: rem(26px);
              vertical-align: text-top;
            }

            &:last-child {
              @include border(left, #e5e5e5);
            }
          }
        }
      }
    }
  }

  .service-flow {
    padding: rem(30px) 0;
    padding-bottom: rem(30px);
    .img {
      margin: 0 auto;
      width: rem(660px);
      height: rem(100px);
      background: url('~@/assets/images/service_lc@3x.png') no-repeat;
      background-size: 100% auto;
    }
  }
  .zl-bz {
    padding-top: rem(40px);
    padding-bottom: rem(30px);
    .img {
      margin: 0 auto;
      width: rem(626px);
      height: rem(404px);
      background: url('~@/assets/images/zl_bz@3x.png') no-repeat;
      background-size: 100% auto;
    }
  }
  .service-bz {
    padding-top: rem(38px);
    padding-bottom: rem(79px);
    .img {
      margin: 0 auto;
      width: rem(690px);
      height: rem(244px);
      background: url('~@/assets/images/service_bz@3x.png') no-repeat;
      background-size: 100% auto;
    }
  }
  .g-right-line {
    // border-right: 1px solid #e5e5e5;
  }
  .g-section {
    margin-top: rem(20px);
    background: #ffffff;
    .g-title {
      display: flex;
      align-items: center;
      padding: rem(30px) rem(20px) 0;
      background: #fff;

      > h2 {
        flex: 1;
        font-size: rem(32px);
        font-weight: 600;

        > span {
          color: #999;
          font-size: rem(28px);
          font-weight: normal;
        }
        > i {
          font-weight: normal;
          color: #999;
          margin: 0 rem(10px);
        }
      }
      > a {
        align-self: flex-start;
        font-size: rem(26px);
      }
      .more {
        font-size: rem(26px);
        text-align: right;
      }
      .icon-jiantou {
        display: inline-block;
        font-size: rem(22px);
        transform: rotate(-90deg);
      }
    }
    .g-info {
    }
  }
  i.pingjia {
    display: inline-block;
    width: rem(44px);
    height: rem(44px);
    background: url('~@/assets/images/icon-pingjia@3x.png') no-repeat;
    background-size: rem(44px) rem(44px);
  }
  >>> .mint-popup {
    background-color: transparent;
  }
}
.btns {
  .btn-list {
    margin: 0 rem(-5px);
    justify-content: space-around;
    display: flex;
    height: rem(80px);
    button {
      flex: 1;
      display: block;
      margin: 0 rem(15px);
      line-height: rem(72px);
      font-size: rem(28px);
      text-align: center;
      border-radius: rem(72px);
    }
    .buy-yuesao {
      color: #262626;
      @include border(all, #ccc, 1px, 0.72rem);
    }
    .consult-ui {
      color: #ffffff;
      background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    }
  }
}
</style>
